import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.settings.block.title',
        defaultMessage: 'Block card?',
    },
    subtitle: {
        id: 'modal.settings.block.subtitle',
        defaultMessage: 'To permanently block your card, please contact support',
    },
    contact: {
        id: 'modal.settings.block.contact',
        defaultMessage: 'Contact support',
    },
    cancel: {
        id: 'modal.settings.block.cancel',
        defaultMessage: 'Cancel',
    },
})
